/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import { useEffect, useRef, useState } from 'react';
import { OverlayTrigger, Tooltip, Row, Button, Table, Alert } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import * as XLSX from 'xlsx';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import axios from 'axios';
import _ from 'lodash';
import guessFormat from 'moment-guess';
import moment from 'moment';
import { loaderActions } from '../../../features/Loader/LoaderSlice';
import API from '../../../Services/API';
import OrderLine from '../OrderLine/Index';
import { formatDate } from '../../../Helpers/date';
import {
  validatePurchaseLine,
  validateTransferLine,
  isSeafreightShipped
} from '../../../Helpers/line.validation';
import { useCurrentCompanyFullName, useCurrentCompanyID } from '../../../hooks/useCurrentCompany';
import { sortLinesByErrors } from '../../../Helpers/sort';
import { CheckRequireApproval } from '../../../Helpers/requireApproval';
import { isPOEligibleToPost } from '../../../Helpers/postable';
import { filterOrdersForVendor } from '../../../Helpers/transferOrderFilters';

function UploadMultipleOrdersLines(props) {
  const dispatch = useDispatch();
  const inputEl = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isErrorDrawerOpen, setIsErrorDrawerOpen] = useState(false);
  const [uploadedLines, setUploadedLines] = useState([]);
  const [uploadedOrders, setUploadedOrders] = useState([]);
  const [postableOrders, setPostableOrders] = useState([]);
  const [dynamicsSaveErrors, setDynamicsSaveErrors] = useState([]);
  const [dynamicsPostErrors, setDynamicsPostErrors] = useState([]);
  const [dynamicsMissingErrors, setDynamicsMissingErrors] = useState([]);
  const { isFeedBackLoopEnabled } = useSelector((state) => state.general);
  const [linesSaveSuccess, setLinesSaveSuccess] = useState(0);
  const [linesPostSuccess, setLinesPostSuccess] = useState(0);
  const [dynamicsReupload, setDynamicsReupload] = useState([]);

  const companyId = useCurrentCompanyID();
  const companyFullName = useCurrentCompanyFullName();

  const clickUpload = () => {
    let line1Text, fieldsList;
    if (props.type === 'purchase') {
      line1Text = `For ${props.vendName} <u><b>${props.vendorType}</b></u> view`;
      if (props.vendorType.toLowerCase() === 'warehouse') {
        fieldsList = `<br /> <ol start="1" class="text-left" style="color: red">
        <li>Warehouse Confirm Quantity</li>
        <li>Warehouse Arrival Date</li>
        <li>Quantity Damaged</li>
      </ol>`;
      } else {
        fieldsList = `<br /> <ol start="1"  class="text-left" style="color: red">
        <li>Vendor Confirm Quantity</li>
        <li>Vendor Shipment Number</li>
        <li>Root Cause</li>
        <li>Expected GRD</li>
        <li>Country Of Origin (required)</li>
        <li>Confirmed Unit Price(if not saved yet)</li>
      </ol>`;
      }
    } else {
      line1Text = `For ${props.vendName} Transfer orders`;
      fieldsList = `<br /> <ol start="1"  class="text-left" style="color: red">
      <li>Quantity Received</li>
      <li>Warehouse Arrival Date</li>
      <li>Quantity Damaged</li>
    </ol>`;
    }
    Swal.fire({
      title: '📁 Mass Upload Instructions',
      icon: 'info',
      html: `
        <div style="text-align: left;">
          <p><strong>${line1Text}</strong></p>
          <p>Only the following fields are updatable:</p>
          ${fieldsList}
          <div style="margin-top: 20px; padding: 15px; background-color: #f8f9fa; border-radius: 8px; border-left: 4px solid #007bff;">
            <p style="margin: 0; color: #495057;"><strong>💡 Tip:</strong> Make sure your Excel file contains the correct column headers and data format.</p>
          </div>
        </div>
      `,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="feather icon-upload"></i> Upload File',
      confirmButtonColor: '#28a745',
      cancelButtonText: '<i class="feather icon-x"></i> Cancel',
      cancelButtonColor: '#6c757d',
      customClass: {
        popup: 'upload-instructions-popup'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        inputEl.current.click();
      }
    });
  };

  const toggleDrawer = () => {
    if (isOpen) {
      setUploadedLines([]);
      setUploadedOrders([]);
      setPostableOrders([]);
    }
    setIsOpen((prevState) => !prevState);
  };

  const toggleErrorDrawer = () => {
    if (isErrorDrawerOpen) {
      setDynamicsSaveErrors([]);
      setDynamicsPostErrors([]);
      setDynamicsMissingErrors([]);
      setDynamicsReupload([]);
    }
    setIsErrorDrawerOpen((prevState) => !prevState);
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      if (props.type === 'purchase') {
        PurchaseExcelToJSON(e.target.files[0]);
      } else {
        TransferExcelToJSON(e.target.files[0]);
      }
    }
    e.target.value = null;
  };

  async function validateLines(actionType) {
    let validatedLines = [];
    if (props.type === 'purchase') {
      validatedLines = uploadedLines.map((line) => {
        const currentOrderLines = uploadedLines.filter(
          (targetLine) => targetLine.documentNo === line.documentNo
        );
        return validatePurchaseLine(
          line,
          props.vendorType,
          currentOrderLines,
          isFeedBackLoopEnabled
        );
      });
    } else {
      validatedLines = uploadedLines.map((line) => validateTransferLine(line));
    }

    setUploadedLines(sortLinesByErrors(validatedLines));
    if (validatedLines.filter((line) => !line.isValid).length === 0) {
      let result;
      let showPopup = false;

      if (props.vendorType === 'Warehouse') {
        const quantityConfirmation = validatedLines.filter((line) => {
          return CheckRequireApproval(line, isFeedBackLoopEnabled) === true;
        });
        if (quantityConfirmation.length > 0) {
          showPopup = true;
        }
      }

      if (isFeedBackLoopEnabled && showPopup) {
        result = await Swal.fire({
          title: 'The amount is over and the PO will need to be approved',
          text: "Please make sure everything is uploaded properly, You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: `Yes, ${actionType} it!`,
          customClass: {
            title: 'swal2-title-red'
          }
        });
      } else {
        result = await Swal.fire({
          title: 'Are you sure?',
          text: "Please make sure everything is uploaded properly, You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: `Yes, ${actionType} it!`
        });
      }
      if (result.isConfirmed) {
        if (actionType.toLowerCase() === 'save') {
          confirmSaveLines();
        } else {
          confirmPostLines();
        }
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please fix all lines invalid inputs...'
      });
    }
  }

  function confirmSaveLines() {
    setLinesSaveSuccess(0);
    setLinesPostSuccess(0);
    setDynamicsReupload([]);
    if (props.type === 'purchase') {
      savePurchaseLine(false);
    } else {
      saveTransferLine(false);
    }
  }

  function confirmPostLines() {
    setLinesSaveSuccess(0);
    setLinesPostSuccess(0);
    setDynamicsReupload([]);
    if (props.type === 'purchase') {
      savePurchaseLine(true);
    } else {
      saveTransferLine(true);
    }
  }

  async function savePurchaseLine(alsoPost = false) {
    dispatch(loaderActions.show());
    let lines = [];
    if (props.vendorType.toLowerCase() === 'warehouse') {
      lines = saveableLines.filter((line) =>
        [
          'Confirmed by Vendor',
          'Confirmation Sent to Warehouse',
          'Confirmed by Warehouse'
        ].includes(line.vendorPortalStatusCaption)
      );
    } else {
      lines = saveableLines.filter((line) =>
        ['Confirmation Sent to Vendor', 'Confirmed by Vendor'].includes(
          line.vendorPortalStatusCaption
        )
      );
    }
    const batchRequestData = saveableLines.map((line) => {
      let data = {};
      if (props.vendorType.toLowerCase() === 'warehouse') {
        data = {
          actualReceiptDate: line.actualReceiptDate,
          qtyDmged: Number(line.qtyDmged),
          qtyMissing: Number(line.qtyMissing),
          SkipPriceValidation: Boolean(line.SkipPriceValidation)
        };
        if (line.vpFreightType === 'SeaRailAir') {
          data = {
            ...data,
            seaFreightConfirmedQty: Number(line.seaFreightConfirmedQty)
          };
        } else {
          data = {
            ...data,
            whseConfirmQty: Number(line.whseConfirmQty)
          };
        }
      } else {
        data = {
          vndrShpmntNo: String(line.vndrShpmntNo),
          vendorConfirmQty: Number(line.vendorConfirmQty),
          expectedReceiptDate: line.expectedReceiptDate,
          lossReason: line.lossReason,
          mfgOriginCountry: line.mfgOriginCountry,
          vpDirectUnitCost: Number(line.vpDirectUnitCost)
        };
      }
      return {
        method: 'PATCH',
        url: `purchaseOrderLinesVP('${line.documentNo}',${line.lineNo},'${line.itemNo}')`,
        headers: {
          Company: companyFullName,
          'Content-Type': 'application/json',
          'If-Match': '*'
        },
        body: data
      };
    });
    if (batchRequestData.length > 0) {
      const subOrderRequestCalls = Math.ceil(batchRequestData.length / 50);
      const batchRequestSubData = [];
      for (let i = 0; i < subOrderRequestCalls; i++) {
        const subOrderRequestData = batchRequestData.slice(i * 50, (i + 1) * 50);
        batchRequestSubData.push(subOrderRequestData);
      }
      const responses = [];
      const errors = [];
      const promises = [];
      batchRequestSubData.forEach((RequestSubData) => {
        promises.push(
          API()
            .post('/purchase-batch', { requests: RequestSubData })
            .then((resp) => responses.push(resp))
            .catch((err) => errors.push(err))
        );
      });
      Promise.all(promises)
        .then(() => {
          const dynamicsErrorsList = [];
          responses.forEach((resp) => {
            resp.data.responses.forEach((POLineResponse) => {
              processDynamicsResponse(resp, POLineResponse, dynamicsErrorsList, alsoPost);
            });
          });
          setDynamicsReupload(dynamicsReupload);
          setDynamicsSaveErrors(dynamicsErrorsList);
          if (alsoPost === false) {
            if (dynamicsSaveErrors.length > 0 || dynamicsMissingErrors.length > 0) {
              toggleDrawer();
              toggleErrorDrawer();
              dispatch(loaderActions.hide());
            } else {
              toggleDrawer();
              dispatch(loaderActions.hide());
              toast.success('Order lines saved successfully');
            }
          }
        })
        .catch(() => {
          console.log(errors);
        });
    }
    if (alsoPost === true) {
      const multiplePostDocs = postableOrders.map((order) => {
        return `/warehouse_post?(${companyId})?('${order}')`;
      });
      const res = await axios.all(
        multiplePostDocs.map((url) =>
          API().post(url, {
            postDate: formatDate(new Date())
          })
        )
      );
      const errors = [];
      res.forEach((err) => {
        if (err.response && typeof err.response === 'object' && err.response.data) {
          const po = err.config.url.split('?')[2].split(`'`)[1];
          const failedLine = uploadedLines.find((line) => line.documentNo === po);
          const error = {
            code: err.code,
            message: err.response.data.message
          };
          addFailedOrderToReupload(failedLine, po, error);
          errors.push({
            po,
            err_code: err.code,
            message: err.response.data.message,
            target_url: err.config.url,
            sent_data: err.config.data
          });
        }
      });
      const postErrors = [...new Set(errors)];
      setDynamicsReupload(dynamicsReupload);
      setDynamicsPostErrors(postErrors);
      if (
        dynamicsPostErrors.length > 0 ||
        dynamicsSaveErrors.length > 0 ||
        postErrors.length > 0 ||
        dynamicsMissingErrors.length > 0
      ) {
        toggleDrawer();
        toggleErrorDrawer();
        dispatch(loaderActions.hide());
      } else {
        toggleDrawer();
        dispatch(loaderActions.hide());
        toast.success('Order lines posted successfully');
      }
    }
  }

  async function saveTransferLine(alsoPost = false) {
    dispatch(loaderActions.show());
    const batchRequestData = uploadedLines.map((line) => {
      const data = {
        actualReceiptDate: line.actualReceiptDate,
        qtyDmged: Number(line.qtyDmged),
        qtyMissing: Number(line.qtyMissing),
        qtyToReceive: Number(line.qtyToReceive),
        mfgOriginCountry: line.mfgOriginCountry
      };
      return {
        method: 'PATCH',
        url: `transferOrderLinesVP('${line.documentNo}',${line.lineNo},'${line.itemNo}')`,
        headers: {
          Company: companyFullName,
          'Content-Type': 'application/json',
          'If-Match': '*'
        },
        body: data
      };
    });
    if (batchRequestData.length > 0) {
      const subOrderRequestCalls = Math.ceil(batchRequestData.length / 50);
      const batchRequestSubData = [];
      for (let i = 0; i < subOrderRequestCalls; i++) {
        const subOrderRequestData = batchRequestData.slice(i * 50, (i + 1) * 50);
        batchRequestSubData.push(subOrderRequestData);
      }
      const responses = [];
      const errors = [];
      const promises = [];
      batchRequestSubData.forEach((RequestSubData) => {
        promises.push(
          API()
            .post('/transfer-batch', { requests: RequestSubData })
            .then((resp) => responses.push(resp))
            .catch((err) => errors.push(err))
        );
      });
      Promise.all(promises)
        .then(() => {
          const dynamicsErrorsList = [];
          responses.forEach((resp) => {
            resp.data.responses.forEach((POLineResponse) => {
              processDynamicsResponse(resp, POLineResponse, dynamicsErrorsList);
            });
          });
          setDynamicsReupload(dynamicsReupload);
          setDynamicsSaveErrors(dynamicsErrorsList);
          if (alsoPost === false) {
            if (dynamicsSaveErrors.length > 0 || dynamicsMissingErrors.length > 0) {
              toggleDrawer();
              toggleErrorDrawer();
              dispatch(loaderActions.hide());
            } else {
              toggleDrawer();
              dispatch(loaderActions.hide());
              toast.success('Order lines saved successfully');
            }
          }
        })
        .catch(() => {
          console.log(errors);
        });
    }
    if (alsoPost === true) {
      const multiplePostDocs = postableOrders.map((order) => {
        return `/transfer_post?(${companyId})?('${order}')`;
      });
      const res = await axios.all(
        multiplePostDocs.map((url) =>
          API().post(url, {
            postDate: formatDate(new Date())
          })
        )
      );
      const errors = [];
      res.forEach((err) => {
        if (err.response && typeof err.response === 'object' && err.response.data) {
          errors.push({
            to: err.config.url.split('?')[2].split(`'`)[1],
            message: err.response.data.message
          });
        }
      });
      const postErrors = [...new Set(errors)];
      setDynamicsPostErrors(postErrors);
      if (
        dynamicsPostErrors.length > 0 ||
        dynamicsSaveErrors.length > 0 ||
        postErrors.length > 0 ||
        dynamicsMissingErrors.length > 0
      ) {
        toggleDrawer();
        toggleErrorDrawer();
        dispatch(loaderActions.hide());
      } else {
        toggleDrawer();
        dispatch(loaderActions.hide());
        toast.success('Order lines posted successfully');
      }
      toggleDrawer();
      dispatch(loaderActions.hide());
    }
  }

  function processDynamicsResponse(resp, POLineResponse, dynamicsErrorsList, alsoPost = false) {
    if (POLineResponse.status !== 200) {
      handleDynamicsFailure(resp, POLineResponse, dynamicsErrorsList);
    } else {
      setLinesSaveSuccess((prev) => prev + 1);
      if (alsoPost === true) {
        setLinesPostSuccess((prev) => prev + 1);
      }
    }
  }

  function handleDynamicsFailure(resp, POLineResponse, dynamicsErrorsList) {
    dynamicsErrorsList.push(POLineResponse.body.error);
    const documentNo = extractDocumentNo(resp.config.data);
    const saveableLine = saveableLines.find((line) => line.documentNo === documentNo);
    if (saveableLine) {
      addFailedOrderToReupload(saveableLine, documentNo, POLineResponse.body.error);
    }
  }

  function extractDocumentNo(url) {
    // This regex matches the first quoted string inside the parentheses
    const match = url.match(/purchaseOrderLinesVP\('([^']+)'/);
    return match ? match[1] : null;
  }

  function addFailedOrderToReupload(failedLine, documentNo, error) {
    const failedOrderData = {
      vendorCode: failedLine.vendorCode,
      warehouseCode: failedLine.warehouseCode,
      documentNo,
      failedOrder: failedLine,
      error
    };
    dynamicsReupload.push(failedOrderData);
  }

  function ExcelDateToJSDate(serial) {
    const utcDays = Math.floor(serial - 25569);
    const utcValue = utcDays * 86400;
    const dateInfo = new Date(utcValue * 1000);
    return `${dateInfo.getFullYear()}-${(dateInfo.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${dateInfo.getDate().toString().padStart(2, '0')}`;
  }

  function ExcelDatetoEVPFormat(date) {
    if (date) {
      const currentFormat = guessFormat(date);
      return moment(date, currentFormat).format('YYYY-MM-DD');
    } else {
      return date;
    }
  }

  const PurchaseExcelToJSON = async (file) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      dispatch(loaderActions.show());
      const binaryString = e.target.result;
      // convert the binary string to a workbook
      const workbook = XLSX.read(binaryString, { type: 'binary' });
      // get the first sheet
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      // convert the sheet to JSON
      const rows = XLSX.utils.sheet_to_json(sheet);
      const rowsData = rows.filter(
        (row) =>
          (Number(row['Vendor Code']) === Number(props.vendorNo) ||
            Number(row['Warehouse Code']) === Number(props.vendorNo)) &&
          row.Type === props.type
      );
      if (rowsData.length === 0) {
        toast.error(`No Purchase Orders matching for Vendor ${props.vendorNo}.`);
        dispatch(loaderActions.hide());
      } else {
        const lines = rows.map((line) => {
          if (props.vendorType.toLowerCase() === 'supplier') {
            // Expected GRD
            if (
              line['Expected GRD (yyyy/mm/dd)'] &&
              typeof line['Expected GRD (yyyy/mm/dd)'] === 'number'
            ) {
              line['Expected GRD (yyyy/mm/dd)'] = ExcelDateToJSDate(
                line['Expected GRD (yyyy/mm/dd)']
              );
            } else {
              line['Expected GRD (yyyy/mm/dd)'] = ExcelDatetoEVPFormat(
                line['Expected GRD (yyyy/mm/dd)']
              );
            }
            return {
              documentNo: line['Order No'],
              lineNo: line['Line No'],
              itemNo: line['Item No'],
              description: line.Description,
              vndrShpmntNo: String(line['Vendor Shipment Number']),
              locationCode: line['Location Code'],
              vendorConfirmQty: Number(line['Vendor Confirm Quantity']),
              expectedReceiptDate: line['Expected GRD (yyyy/mm/dd)'],
              whseConfirmQty: Number(line['Warehouse Confirm Quantity']),
              actualReceiptDate: line['Actual Receipt Date (yyyy/mm/dd)'],
              qtyDmged: Number(line['Quantity Damaged']),
              lossReason: line['Root Cause'],
              mfgOriginCountry: line['Country Of Origin'],
              vpDirectUnitCost: Number(line['Confirmed Unit Price']),
              isValid: true,
              editedFields: [],
              validationErrors: [],
              validationWarnings: [],
              vendorCode: line['Vendor Code'],
              warehouseCode: line['Warehouse Code'],
              type: line.Type,
              ShippingMethod: line['Shipping Method'],
              expectedGRD: line['Expected GRD (yyyy/mm/dd)'],
              plannedGRD: line['Planned GRD (Not updatable)'],
              expectedDeliveryDate: line['Expected Delivery Date'],
              warehouseArrivalDate: line['Warehouse Arrival Date (yyyy/mm/dd)'],
              vendorShipmentNo: Number(line['Vendor Shipment Number']),
              actualShippingDate: line['Actual Shipping Date (yyyy/mm/dd)']
            };
          } else {
            if (typeof line['Warehouse Arrival Date (yyyy/mm/dd)'] === 'number') {
              line['Warehouse Arrival Date (yyyy/mm/dd)'] = ExcelDateToJSDate(
                line['Warehouse Arrival Date (yyyy/mm/dd)']
              );
            } else {
              line['Warehouse Arrival Date (yyyy/mm/dd)'] = ExcelDatetoEVPFormat(
                line['Warehouse Arrival Date (yyyy/mm/dd)']
              );
            }
            return {
              documentNo: line['Order No'],
              lineNo: line['Line No'],
              itemNo: line['Item No'],
              description: line.Description,
              vndrShpmntNo: String(line['Vendor Shipment Number']),
              locationCode: line['Location Code'],
              quantity: Number(line.Quantity),
              vendorConfirmQty: Number(line['Vendor Confirm Quantity']),
              wareHouseQty: Number(line['Warehouse Confirm Quantity']),
              actualReceiptDate: line['Warehouse Arrival Date (yyyy/mm/dd)'],
              qtyDmged: Number(line['Quantity Damaged']),
              lossReason: line['Root Cause'],
              isValid: true,
              editedFields: [],
              validationErrors: [],
              validationWarnings: [],
              vendorCode: line['Vendor Code'],
              warehouseCode: line['Warehouse Code'],
              type: line.Type,
              ShippingMethod: line['Shipping Method'],
              expectedGRD: line['Expected GRD (yyyy/mm/dd)'],
              plannedGRD: line['Planned GRD (Not updatable)'],
              expectedDeliveryDate: line['Expected Delivery Date (yyyy/mm/dd)'],
              warehouseArrivalDate: line['Warehouse Arrival Date (yyyy/mm/dd)'],
              actualShippingDate: line['Actual Shipping Date (yyyy/mm/dd)']
            };
          }
        });
        setUploadedLines(lines);
        loadOrdersData('/purchase_order_header', lines, props.vendorType);
      }
    };

    reader.onerror = function (ex) {
      dispatch(loaderActions.hide());
      console.log(ex);
    };
    reader.readAsBinaryString(file);
  };

  const TransferExcelToJSON = (file) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      dispatch(loaderActions.show());
      const binaryString = e.target.result;
      // convert the binary string to a workbook
      const workbook = XLSX.read(binaryString, { type: 'binary' });
      // get the first sheet
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      // convert the sheet to JSON
      const rows = XLSX.utils.sheet_to_json(sheet);
      const rowsData = rows.filter(
        (row) =>
          (Number(row['Vendor Code']) === Number(props.vendorNo) ||
            Number(row['Warehouse Code']) === Number(props.vendorNo)) &&
          row.Type === props.type
      );
      if (rowsData.length === 0) {
        toast.error(`No Transfer Orders matching for Vendor ${props.vendorNo}.`);
        dispatch(loaderActions.hide());
      } else {
        const lines = rowsData.map((line) => {
          if (typeof line['Warehouse Arrival Date (yyyy/mm/dd)'] === 'number') {
            line['Warehouse Arrival Date (yyyy/mm/dd)'] = ExcelDateToJSDate(
              line['Warehouse Arrival Date (yyyy/mm/dd)']
            );
          }
          return {
            documentNo: line['Order No'],
            lineNo: line['Line No'],
            itemNo: line['Item No'],
            description: line.Description,
            itemQty: Number(line.Quantity),
            expectedReceiptDate: line['Expected GRD (yyyy/mm/dd)'],
            qtyToReceive: Number(line['Quantity Received']),
            actualReceiptDate: line['Warehouse Arrival Date (yyyy/mm/dd)'],
            qtyDmged: Number(line['Quantity Damaged']),
            qtyMissing: Number(line['Quantity Missing']),
            isValid: true,
            validationErrors: [],
            validationWarnings: [],
            editedFields: []
          };
        });
        setUploadedLines(lines);
        loadOrdersData('/transfer_order_header', lines, props.vendorType);
      }
    };

    reader.onerror = function (ex) {
      dispatch(loaderActions.hide());
      console.log(ex);
    };
    reader.readAsBinaryString(file);
  };

  async function loadOrdersData(endpoint, lines, VendorType) {
    const uniqueOrders = [...new Set(lines.map((line) => line.documentNo))];
    let filter = '';
    await uniqueOrders.forEach((order, index) => {
      if (index === 0) {
        filter = `contains(docNo, '${order}')`;
      } else {
        filter = filter + ` or contains(docNo, '${order}')`;
      }
    });
    const params = {
      company_id: companyId,
      $select: `docNo,status`,
      $filter: filter
    };
    if (props.type === 'purchase') {
      params.$select = `docNo,status,vendorPortalStatus,vendorPortalStatusCaption`;
    } else {
      // Don't restrict $select here: filterOrdersForVendor needs receiptStatus and
      // transferToName, and $select-ing an unrecognized/undeployed field errors
      // the whole request the same way an unrecognized $filter field does.
      delete params.$select;
    }
    const res = await API().get(endpoint, { params });
    const ordersList = filterOrdersForVendor(res.data.value, props.type);
    let linesToProcess = lines;

    if (props.type === 'transfer') {
      // Orders hidden from this vendor are treated as if they don't exist at
      // all - no error, their lines just don't make it into the upload.
      const visibleDocNos = new Set(ordersList.map((order) => order.docNo));
      linesToProcess = lines.filter((line) => visibleDocNos.has(line.documentNo));
      setUploadedLines(linesToProcess);
    }
    setUploadedOrders(ordersList);

    if (props.type === 'transfer') {
      if (linesToProcess.length === 0) {
        dispatch(loaderActions.hide());
      } else {
        loadTransferLinesData(linesToProcess);
      }
    } else {
      loadPurchaseLinesData(lines, VendorType);
    }
  }

  async function loadTransferLinesData(lines) {
    const uniqueOrders = [...new Set(lines.map((line) => line.documentNo))];
    let filter = '';
    await uniqueOrders.forEach((order, index) => {
      if (index === 0) {
        filter = `contains(documentNo, '${order}')`;
      } else {
        filter = filter + ` or contains(documentNo, '${order}')`;
      }
    });
    const params = {
      company_id: companyId,
      $select: `documentNo,lineNo,qtyShipped,itemQty`,
      $filter: filter
    };
    const res = await API().get('/transfer_order_lines', { params });
    const updatedLines = [];
    lines.forEach((targetLine) => {
      const updateLine = res.data.value.find(
        (line) => line.documentNo === targetLine.documentNo && line.lineNo === targetLine.lineNo
      );
      if (updateLine !== undefined && targetLine !== undefined) {
        let qtyMissing = updateLine.itemQty - (updateLine?.qtyShipped + targetLine?.qtyToReceive);
        if (qtyMissing < 0) {
          qtyMissing = 0;
        }
        updatedLines.push({
          ...targetLine,
          vendorPortalStatusCaption: 'Confirmation Sent to Warehouse',
          qtyMissing,
          itemQty: updateLine.itemQty,
          qtyShipped: updateLine.qtyShipped
        });
      }
    });
    setUploadedLines(sortLinesByErrors(updatedLines));
    dispatch(loaderActions.hide());
    toggleDrawer();
  }

  async function loadPurchaseLinesData(lines, VendorType) {
    const uniqueOrders = [...new Set(lines.map((line) => line.documentNo))];
    let filter = '';
    await uniqueOrders.forEach((order, index) => {
      if (index === 0) {
        filter = `contains(documentNo, '${order}')`;
      } else {
        filter = filter + ` or contains(documentNo, '${order}')`;
      }
    });
    let select = [
      'documentNo',
      'lineNo',
      'quantity',
      'originalQuantity',
      'qtyReceived',
      'vendorConfirmQty',
      'expectedReceiptDate',
      'plannedReceiptDate',
      'expectedDeliveryDate',
      'actualShippingDate',
      'vendorPortalStatus',
      'vendorPortalStatusCaption',
      'overReceiptCode',
      'directUnitCost',
      'vpFreightType',
      'lossReason',
      'mfgOriginCountry',
      'vpDirectUnitCost'
    ];
    if (isFeedBackLoopEnabled === true) {
      select = [...select, 'feedbackDate', 'feedbackStatus', 'feedbackType', 'feedbackUser'];
    }

    const params = {
      company_id: companyId,
      $select: select.join(','),
      $filter: filter
    };
    const res = await API().get('/purchase_order_lines', { params });
    let updatedLines = [];
    lines.forEach((targetLine) => {
      const updateLine = res.data.value.find(
        (line) => line.documentNo === targetLine.documentNo && line.lineNo === targetLine.lineNo
      );
      if (updateLine) {
        let qtyMissing =
          updateLine.vendorConfirmQty - (updateLine.qtyReceived + targetLine.wareHouseQty);
        if (qtyMissing < 0) {
          qtyMissing = 0;
        }
        let quantity = {
          quantity: updateLine.quantity,
          vendorConfirmQty: targetLine.vendorConfirmQty
            ? targetLine.vendorConfirmQty
            : updateLine.vendorConfirmQty,
          vpFreightType: updateLine.vpFreightType
        };
        if (updateLine.vpFreightType === 'SeaRailAir') {
          quantity = {
            ...quantity,
            seaFreightConfirmedQty: Number(targetLine.wareHouseQty)
          };
        } else {
          quantity = {
            ...quantity,
            whseConfirmQty: Number(targetLine.wareHouseQty)
          };
        }
        if (VendorType.toLowerCase() === 'warehouse') {
          targetLine.lossReason = updateLine.lossReason;
        }
        delete targetLine.wareHouseQty;
        if (isFeedBackLoopEnabled === true) {
          updatedLines.push({
            ...targetLine,
            ...quantity,
            id: `${targetLine.documentNo}_${targetLine.lineNo}`,
            qtyMissing,
            expectedReceiptDate: updateLine.expectedReceiptDate,
            actualShippingDate: updateLine.actualShippingDate,
            vendorPortalStatus: updateLine.vendorPortalStatus,
            vendorPortalStatusCaption: updateLine.vendorPortalStatusCaption,
            originalQuantity: updateLine.originalQuantity,
            qtyReceived: updateLine.qtyReceived,
            feedbackDate: updateLine.feedbackDate,
            feedbackStatus: updateLine.feedbackStatus,
            feedbackType: updateLine.feedbackType,
            feedbackUser: updateLine.feedbackUser,
            overReceiptCode: updateLine.overReceiptCode,
            directUnitCost: updateLine.directUnitCost,
            plannedReceiptDate: updateLine.plannedReceiptDate,
            vpDirectUnitCost: updateLine.vpDirectUnitCost
              ? updateLine.vpDirectUnitCost
              : targetLine.vpDirectUnitCost,
            isVpDirectUnitCostEditable: !updateLine.vpDirectUnitCost
          });
        } else {
          updatedLines.push({
            ...targetLine,
            ...quantity,
            id: `${targetLine.documentNo}_${targetLine.lineNo}`,
            qtyMissing,
            actualShippingDate: updateLine.actualShippingDate,
            vendorPortalStatus: updateLine.vendorPortalStatus,
            vendorPortalStatusCaption: updateLine.vendorPortalStatusCaption,
            quantity: updateLine.quantity,
            originalQuantity: updateLine.originalQuantity,
            qtyReceived: updateLine.qtyReceived,
            overReceiptCode: updateLine.overReceiptCode,
            directUnitCost: updateLine.directUnitCost,
            plannedReceiptDate: updateLine.plannedReceiptDate,
            vpDirectUnitCost: updateLine.vpDirectUnitCost
              ? updateLine.vpDirectUnitCost
              : targetLine.vpDirectUnitCost,
            isVpDirectUnitCostEditable: !updateLine.vpDirectUnitCost
          });
        }
      } else {
        addMissingOrderToErrorsAndToReupload(targetLine);
      }
    });
    updatedLines = _.uniqBy(updatedLines, 'id');
    setUploadedLines(sortLinesByErrors(updatedLines));
    setDynamicsReupload(dynamicsReupload);
    setDynamicsMissingErrors(dynamicsMissingErrors);
    dispatch(loaderActions.hide());
    toggleDrawer();
  }
  function addMissingOrderToErrorsAndToReupload(targetLine) {
    const missingOrder = {
      vendorCode: targetLine.vendorCode,
      warehouseCode: targetLine.warehouseCode,
      documentNo: targetLine.documentNo,
      failedOrder: targetLine,
      error: {
        code: 'BusinessCentral_OrderNotFound',
        message: 'Order not found in Business Central.'
      }
    };
    dynamicsReupload.push(missingOrder);
    dynamicsMissingErrors.push(missingOrder);
  }

  function editValue(documentNo, lineNo, targetField) {
    if (!targetField) return;
    const targetKey = Object.keys(targetField)[0];
    setUploadedLines((prevState) => {
      return prevState.map((line) => {
        if (line.documentNo === documentNo && lineNo === line.lineNo) {
          line[targetKey] = targetField[targetKey];
        }
        return line;
      });
    });

    if (
      (targetKey === 'whseConfirmQty' && targetField[targetKey] > 0) ||
      (targetKey === 'seaFreightConfirmedQty' && targetField[targetKey] > 0)
    ) {
      setUploadedLines((prevState) => {
        return prevState.map((line) => {
          if (line.documentNo === documentNo && lineNo === line.lineNo) {
            let qtyMissing = line.vendorConfirmQty - (line.qtyReceived + targetField[targetKey]);
            if (qtyMissing < 0) {
              qtyMissing = 0;
            }
            line.qtyMissing = qtyMissing;
          }
          return line;
        });
      });
    }

    if (targetKey === 'qtyToReceive' && targetField[targetKey] > 0) {
      setUploadedLines((prevState) => {
        return prevState.map((line) => {
          if (line.documentNo === documentNo && lineNo === line.lineNo) {
            let qtyMissing = line.itemQty - (line.qtyShipped + targetField[targetKey]);
            if (qtyMissing < 0) {
              qtyMissing = 0;
            }
            line.qtyMissing = qtyMissing;
          }
          return line;
        });
      });
    }
  }

  function downloadFailedOrdersToReupload() {
    const failedOrder = purchaseOrderWithErrorsJsonToExcel(dynamicsReupload);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(failedOrder);

    XLSX.utils.book_append_sheet(wb, ws, 'Errors');

    autoSizeExcelColumn(failedOrder, ws);

    const fileName = `${props.vendName}_${props.vendorType}_failed_orders.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  function autoSizeExcelColumn(failedOrder, ws) {
    // Calculate max width for each column
    const cols = Object.keys(failedOrder[0] || {});
    const colWidths = cols.map((col) => {
      // Start with the header width
      let maxLen = col.length;
      // Check each row's value for this column
      failedOrder.forEach((row) => {
        const value = row[col];
        if (value !== undefined && value !== null) {
          const len = value.toString().length;
          if (len > maxLen) maxLen = len;
        }
      });
      return { wch: maxLen + 2 };
    });

    ws['!cols'] = colWidths;
  }

  function purchaseOrderWithErrorsJsonToExcel(orders) {
    // If a single order is passed, wrap it in an array
    if (!Array.isArray(orders)) orders = [orders];
    // Map the order(s) to the excel structure
    return orders.map((order) => {
      const line = order.failedOrder;
      return {
        'Vendor Code': line.vendorCode,
        'Warehouse Code': line.warehouseCode,
        'Order No': line.documentNo,
        'Line No': line.lineNo,
        'Item No': line.itemNo,
        Type: line.type,
        Description: line.description,
        'Location Code': line.locationCode,
        'Shipping Method': line.ShippingMethod,
        'Expected GRD (yyyy/mm/dd)': line.expectedGRD,
        'Planned GRD (Not updatable)': line.plannedGRD,
        'Expected Delivery Date': line.expectedDeliveryDate,
        'Actual Shipping Date (yyyy/mm/dd)':
          order.failedOrder.actualShippingDate || line.actualShippingDate,
        'Warehouse Confirm Quantity':
          order.failedOrder.wareHouseQty ||
          line.wareHouseQty ||
          order.failedOrder.whseConfirmQty ||
          line.whseConfirmQty,
        'Warehouse Arrival Date (yyyy/mm/dd)': line.warehouseArrivalDate,
        'Quantity Damaged': line.qtyDmged || order.failedOrder.qtyDmged,
        'Vendor Shipment Number': order.failedOrder.vendorShipmentNo,
        'Error Code': order.error.code,
        'Error Message': order.error.message
      };
    });
  }

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }
  }, [isOpen]);

  const uploadedRows = uploadedLines.map((line, index) => {
    const currentOrderLines = uploadedLines.filter(
      (targetLine) => targetLine.documentNo === line.documentNo
    );
    return (
      <OrderLine
        documentNo={line.documentNo}
        line={line}
        index={index}
        vendorType={props.vendorType}
        key={line.documentNo + '_' + line.lineNo + '_' + line.itemNo}
        type={props.type}
        editValue={editValue}
        showSaveButton={false}
        showOrderLink={true}
        directLink={props.directLink}
        orderLines={currentOrderLines}
        isBackendLines={true}
      />
    );
  });

  useEffect(() => {
    let linesByPo = _.groupBy(uploadedLines, 'documentNo');
    uploadedLines.forEach((line) => {
      if (line.vpFreightType === 'SeaRailAir') {
        linesByPo = _.omit(linesByPo, line.documentNo);
      }
    });
    const postablePos = [];
    for (const key in linesByPo) {
      const notPostableLine = _.filter(linesByPo[key], (line) => {
        return CheckRequireApproval(line, isFeedBackLoopEnabled) === true;
      });
      if (notPostableLine.length === 0) {
        const targetPo = uploadedOrders.find((po) => po.docNo === key);
        if (targetPo && isPOEligibleToPost(props.vendorType, targetPo, linesByPo[key], [], [])) {
          postablePos.push(key);
        }
      }
    }
    setPostableOrders(postablePos);
  }, [uploadedLines]);

  const saveableLines = (
    isFeedBackLoopEnabled
      ? uploadedLines.filter((line) => line.feedbackStatus !== 'Pending')
      : uploadedLines
  ).filter((line) => !isSeafreightShipped(line));

  return (
    <>
      <OverlayTrigger
        key="upload"
        className="mr-2"
        placement={'top'}
        overlay={
          <Tooltip id={`tooltip-upload`} role={'button'}>
            <strong>Mass Upload</strong>
            <br />
            Upload multiple order lines via Excel
          </Tooltip>
        }
      >
        <Button
          variant="outline-primary"
          size="sm"
          className="upload-btn"
          onClick={clickUpload}
          style={{
            borderRadius: '6px',
            padding: '2px 4px',
            border: '1px solid #007bff',
            backgroundColor: '#f8f9fa',
            transition: 'all 0.3s ease',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            marginRight: '4px',
            marginLeft: '4px'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#e3f2fd';
            e.target.style.borderColor = '#0056b3';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#f8f9fa';
            e.target.style.borderColor = '#007bff';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          <i className="feather icon-upload" style={{ fontSize: '16px' }} />
        </Button>
      </OverlayTrigger>

      <Drawer
        open={isOpen}
        onClose={() => {
          toggleDrawer();
        }}
        direction="right"
        size={'80vw'}
        style={{
          zIndex: '10000',
          overflowX: 'hidden',
          overflowY: 'scroll',
          paddingBottom: '10vh'
        }}
      >
        <div className="p-4" style={{ borderBottom: '1px solid #e9ecef' }}>
          <div className="row align-items-center">
            <div className="col">
              <h5 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>
                📋 Review Upload
              </h5>
              {uploadedLines.length > 0 && (
                <div className="mt-2">
                  <div className="d-flex align-items-center">
                    <div className="progress flex-grow-1 me-3" style={{ height: '8px' }}>
                      <div
                        className="progress-bar bg-success"
                        style={{
                          width: `${(saveableLines.length / uploadedLines.length) * 100}%`,
                          transition: 'width 0.3s ease'
                        }}
                      />
                    </div>
                    <small className="text-muted">
                      {saveableLines.length} of {uploadedLines.length} lines ready
                    </small>
                  </div>
                </div>
              )}
            </div>
            <div className="col-auto">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={toggleDrawer}
                style={{
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  padding: '0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <i className="feather icon-x" style={{ fontSize: '18px' }} />
              </Button>
            </div>
          </div>
          {uploadedLines.length > 0 && (
            <Row className="mt-3">
              <div className="col">
                <div className="d-flex gap-2 flex-wrap">
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => validateLines('Save')}
                    style={{
                      borderRadius: '20px',
                      padding: '8px 20px',
                      fontWeight: '500'
                    }}
                  >
                    <i className="feather icon-save me-2" />
                    Save Lines ({saveableLines.length}/{uploadedLines.length})
                  </Button>
                  {props.vendorType &&
                    props.vendorType.toLowerCase() === 'warehouse' &&
                    postableOrders.length > 0 && (
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => validateLines('Post')}
                        style={{
                          borderRadius: '20px',
                          padding: '8px 20px',
                          fontWeight: '500'
                        }}
                      >
                        <i className="feather icon-check-circle me-2" />
                        Post POs ({postableOrders.length}/{uploadedOrders.length})
                      </Button>
                    )}
                </div>
              </div>
            </Row>
          )}
        </div>
        {uploadedLines.length > 0 && <div className="row mt-2 px-4">{uploadedRows}</div>}
        {uploadedLines.length > 0 && (
          <Row className="mt-4 px-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="info" onClick={() => validateLines('Save')}>
              Save Lines ({saveableLines.length}/{uploadedLines.length})
            </Button>
            {props.vendorType &&
            props.vendorType.toLowerCase() === 'warehouse' &&
            postableOrders.length > 0 ? (
              <Button variant="primary" className="ml-2" onClick={() => validateLines('Post')}>
                Post POs ({postableOrders.length}/{uploadedOrders.length})
              </Button>
            ) : (
              <></>
            )}
          </Row>
        )}
        {uploadedLines.length === 0 && (
          <div className="d-flex flex-column align-items-center justify-content-center py-5">
            <div className="mb-4">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#fff3cd',
                  color: '#856404'
                }}
              >
                <i className="feather icon-alert-circle" style={{ fontSize: '40px' }} />
              </div>
            </div>
            <h5 className="mb-3" style={{ color: '#856404', fontWeight: '600' }}>
              No Valid Lines Found
            </h5>
            <p className="text-muted text-center mb-4" style={{ maxWidth: '400px' }}>
              The uploaded file either contains no valid data or all orders are already posted.
              Please check your Excel file and try again.
            </p>
            <Button
              variant="outline-warning"
              size="sm"
              onClick={toggleDrawer}
              style={{
                borderRadius: '20px',
                padding: '8px 20px'
              }}
            >
              <i className="feather icon-upload me-2" />
              Try Another File
            </Button>
          </div>
        )}
      </Drawer>

      <Drawer
        open={isErrorDrawerOpen}
        onClose={toggleErrorDrawer}
        direction="right"
        size={'80vw'}
        style={{
          zIndex: '10000',
          overflowX: 'hidden',
          overflowY: 'scroll',
          paddingBottom: '10vh'
        }}
      >
        <div className="p-4" style={{ borderBottom: '1px solid #e9ecef' }}>
          <div className="row align-items-center">
            <div className="col">
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: '#d1ecf1',
                      color: '#0c5460'
                    }}
                  >
                    <i className="feather icon-info" style={{ fontSize: '24px' }} />
                  </div>
                </div>
                <div>
                  <h5 className="mb-1" style={{ color: '#0c5460', fontWeight: '600' }}>
                    Upload Summary {linesSaveSuccess} lines successfully uploaded and{' '}
                    {linesPostSuccess} lines successfully posted
                  </h5>
                  <p className="mb-0 text-muted">
                    The Following Errors were caught while Uploading
                    {dynamicsSaveErrors.length > 0 ||
                      dynamicsPostErrors.length > 0 ||
                      (dynamicsMissingErrors.length > 0 && (
                        <span className="ms-2">
                          {'•'}
                          <strong className="text-danger">
                            {
                              dynamicsSaveErrors
                                .concat(dynamicsPostErrors)
                                .concat(dynamicsMissingErrors).length
                            }
                          </strong>
                          errors found
                        </span>
                      ))}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  if (isOpen) {
                    toggleDrawer();
                  }
                  toggleErrorDrawer();
                  // Refresh the page after closing the error drawer
                  setTimeout(() => {
                    window.location.reload();
                  }, 100);
                }}
                style={{
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  padding: '0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <i className="feather icon-x" style={{ fontSize: '18px' }} />
              </Button>
            </div>
          </div>
        </div>
        <div className="px-4 py-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="me-3">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: '#f8d7da',
                    color: '#721c24'
                  }}
                >
                  <i
                    className="feather icon-alert-triangle"
                    style={{ color: '#721c24', fontSize: '16px' }}
                  />
                </div>
              </div>
              <div>
                <h6 className="mb-0" style={{ color: '#721c24', fontWeight: '600' }}>
                  {dynamicsReupload.length} lines failed to be uploaded. (Use the file downloaded
                  here to reupload once the errors are fixed)
                </h6>
              </div>
            </div>
            <Button
              variant="outline-warning"
              size="sm"
              onClick={() => downloadFailedOrdersToReupload()}
              style={{
                borderRadius: '20px',
                padding: '6px 16px',
                fontSize: '14px'
              }}
            >
              <i className="feather icon-download me-2" />
              Download Failed Lines File ({dynamicsReupload.length})
            </Button>
          </div>
        </div>
      </Drawer>
      <input
        type="file"
        ref={inputEl}
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </>
  );
}

export default UploadMultipleOrdersLines;
